<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId; else previewBlock">
    <div *ngIf="pricingState && isTraded; else handleNoPricingData" edsGrid>
      <ft-bar-chart *ngIf="currentPeriod" [data]="chart">
        <!-- TODO: needs EDS design kit -->
        <div edsRow edsSpacing="md">
          <eds-dropdown
            edsCol
            [columnNumbers]="{ s: 4, m: 2, l: 3 }"
            [label]="'products.select-a-quarter' | translate"
            [items]="data.periods"
            [multi]="false"
            [preselectedValue]="currentPeriod"
            (dropdownChange)="onQuarterChange($event)"
          ></eds-dropdown>
        </div>
        <div edsSpacing="lg">
          <div edsCssCols [maxCols]="2" colGap="xxxl">
            <!-- Info Items -->
            <eds-info-item
              *ngFor="let item of currentPeriod.statistics"
              [info]="item"
              edsSpacing="xs"
            ></eds-info-item>
          </div>
        </div>
      </ft-bar-chart>

      <ft-premium-discount-elevated
        *ngIf="pricingState.premiumDiscountElevated"
        [elevatedPeriods]="pricingState.premiumDiscountElevated"
      ></ft-premium-discount-elevated>

      <!-- reuse <ft-pricing-chart> to display premium Discount History Chart -->
      <ft-pricing-chart
        *ngIf="pricingState.premiumDiscountHistory"
        [chartConfig]="pricingState.premiumDiscountHistory"
        [minDateStd]="pricingState.pricingConfig.dateValues.incDateStd"
        [maxDateStd]="pricingState.pricingConfig.dateValues.asOfDateStd"
        [navAsOfDate]="pricingState.overviewData.nav.navAsOfDate"
        [performanceInceptionDateStd]="
          pricingState.overviewData.shareClass.performanceInceptionDateStd
        "
        [fundId]="brConfig.fundId"
        (toggleChartRangeUpdated)="updatePremiumDiscountChart($event)"
      ></ft-pricing-chart>
    </div>

    <ng-template #handleNoPricingData>
      <span *ngIf="isTraded">{{
        "products.price-no-data-error" | translate
      }}</span>
    </ng-template>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <h5>Premium Discount Analysis</h5>
</ng-template>
